import script from "./UsersToBeArchived.vue?vue&type=script&setup=true&lang=ts"
export * from "./UsersToBeArchived.vue?vue&type=script&setup=true&lang=ts"

import "./UsersToBeArchived.vue?vue&type=style&index=0&id=33e8d095&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33e8d095"]])

export default __exports__